import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WORKFLOW_MODULE_ID } from 'constants/workflow.constants';

@Component({
  selector: 'cm-certification-card',
  templateUrl: './certification-card.component.html',
  styleUrls: ['./certification-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificationCardComponent implements OnInit {
  @Input() certification;
  showMore = false;
  workflowTypeId: number;
  WORKFLOW_MODULE_ID = WORKFLOW_MODULE_ID;
  get showDetailsLabel(): string {
    return this.showMore ? 'Show less' : 'Show more';
  }

  constructor(private activateRoute: ActivatedRoute) {}

  ngOnInit() {
    this.workflowTypeId = Number(this.activateRoute.snapshot.params.workflowTypeId);
  }

  toggleDetails(event) {
    event.stopPropagation();
    this.showMore = !this.showMore;
  }
}
